import MaintenancePage from "../MaintenancePage";
import { DataGridSettingsProvider } from "@/components/DataGridSettingsProvider";

export function MaintenancePageWrapper() {
  return (
    <DataGridSettingsProvider pageType="maintenance">
      <MaintenancePage />
    </DataGridSettingsProvider>
  );
}
